"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonaVerificationStatus = exports.isPersonaTerminalFailureStatus = exports.PERSONA_TERMINAL_SESSION_FAILURE_STATUSES = exports.PERSONA_SUCCESS_STATUSES = exports.PERSONA_TERMINAL_SESSION_STATUSES = exports.PERSONA_NOT_ATTEMPTED_STATUSES = exports.PersonaInquiryStatus = exports.SsnConfirmationResult = void 0;
var SsnConfirmationResult;
(function (SsnConfirmationResult) {
    SsnConfirmationResult["confirmed"] = "confirmed";
    // Did not match the SSN on file; the applicant can try again.
    SsnConfirmationResult["retry"] = "retry";
    // Did not match on the last try: SSNMismatch is raised and the applicant continues to Persona.
    SsnConfirmationResult["mismatch"] = "mismatch";
})(SsnConfirmationResult || (exports.SsnConfirmationResult = SsnConfirmationResult = {}));
/**
 * Persona inquiry statuses
 * See: https://docs.withpersona.com/docs/models-lifecycle#inquiry-statuses
 */
var PersonaInquiryStatus;
(function (PersonaInquiryStatus) {
    PersonaInquiryStatus["completed"] = "completed";
    PersonaInquiryStatus["failed"] = "failed";
    PersonaInquiryStatus["needs_review"] = "needs_review";
    PersonaInquiryStatus["created"] = "created";
    PersonaInquiryStatus["pending"] = "pending";
    PersonaInquiryStatus["expired"] = "expired";
    PersonaInquiryStatus["approved"] = "approved";
    PersonaInquiryStatus["declined"] = "declined";
})(PersonaInquiryStatus || (exports.PersonaInquiryStatus = PersonaInquiryStatus = {}));
exports.PERSONA_NOT_ATTEMPTED_STATUSES = [PersonaInquiryStatus.created, PersonaInquiryStatus.pending, PersonaInquiryStatus.expired];
exports.PERSONA_TERMINAL_SESSION_STATUSES = [
    PersonaInquiryStatus.needs_review,
    PersonaInquiryStatus.failed,
    PersonaInquiryStatus.completed,
    PersonaInquiryStatus.approved,
    PersonaInquiryStatus.declined,
];
exports.PERSONA_SUCCESS_STATUSES = [PersonaInquiryStatus.completed, PersonaInquiryStatus.approved];
exports.PERSONA_TERMINAL_SESSION_FAILURE_STATUSES = [PersonaInquiryStatus.failed, PersonaInquiryStatus.declined, PersonaInquiryStatus.needs_review];
const terminalFailureStatuses = exports.PERSONA_TERMINAL_SESSION_FAILURE_STATUSES;
const isPersonaTerminalFailureStatus = (status) => terminalFailureStatuses.includes(status);
exports.isPersonaTerminalFailureStatus = isPersonaTerminalFailureStatus;
/** Aven's reading of a Persona inquiry's outcome, which the notary console shows for the signer. */
var PersonaVerificationStatus;
(function (PersonaVerificationStatus) {
    // Shown to the notary as Not Started
    PersonaVerificationStatus["notStarted"] = "not_started";
    // Shown to the notary as In Progress
    PersonaVerificationStatus["pendingComplete"] = "pending_complete";
    // Shown to the notary as Done
    PersonaVerificationStatus["passed"] = "passed";
    PersonaVerificationStatus["failed"] = "failed";
    PersonaVerificationStatus["declined"] = "declined";
    PersonaVerificationStatus["needsReview"] = "needs_review";
    PersonaVerificationStatus["expired"] = "expired";
})(PersonaVerificationStatus || (exports.PersonaVerificationStatus = PersonaVerificationStatus = {}));
